import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const CheckInCircleIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <circle cx="12" cy="12" r="10" fill={getColor(secondaryColor)} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.04979C6.50477 2.04979 2.05001 6.50456 2.05001 11.9998C2.05001 17.495 6.50477 21.9498 12 21.9498C17.4952 21.9498 21.95 17.495 21.95 11.9998C21.95 6.50456 17.4952 2.04979 12 2.04979ZM0.350006 11.9998C0.350006 5.56568 5.56589 0.349792 12 0.349792C18.4341 0.349792 23.65 5.56568 23.65 11.9998C23.65 18.4339 18.4341 23.6498 12 23.6498C5.56589 23.6498 0.350006 18.4339 0.350006 11.9998Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8119 9.04917L17.7351 9.11548L17.7279 9.12144C15.3103 11.1131 13.0981 13.3415 11.1208 15.7771L10.4482 16.6055L9.78854 15.6752C8.74987 14.3044 7.52036 13.076 6.14728 12.0291L7.1297 10.7406C8.37351 11.689 9.50987 12.7758 10.5086 13.9771C12.3843 11.7623 14.4521 9.72157 16.6904 7.87689L16.753 7.82281L17.8119 9.04917Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default CheckInCircleIconFilled;
